export function getVistaHostKey(): string {
    return process.env.NEXT_PUBLIC_USE_STAGING === 'true'
        ? 'staging.vistaprint.com'
        : 'vistaprint.com';
}
